import '@/assets/styles/index.css';
import { useServiceWorker } from '@/composables/useServiceWorker';
import i18n from '@/i18n';
import pinia from '@/pinia';
import router from '@/router';
import { initSentry } from '@/sentry';
import { createApp } from 'vue';
import App from './App.vue';

const app = createApp(App);

initSentry(app, () => router.currentRoute.value.name);

app.use(pinia);
app.use(router);
app.use(i18n);

app.mount('#app');

// Register service worker for PWA support
const { register } = useServiceWorker();
register();
